import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

export function TermsPage() {
  return (
    <div className="bg-white min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center text-slate-500 hover:text-blue-600 mb-8 transition-colors">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Volver al inicio
        </Link>
        
        <div className="flex items-center gap-3 mb-6">
          <div className="p-3 bg-blue-50 rounded-xl">
            <FileText className="w-8 h-8 text-blue-600" />
          </div>
          <h1 className="text-3xl font-bold text-slate-900">Términos y Condiciones</h1>
        </div>

        <div className="prose prose-slate max-w-none text-slate-600">
          <p className="lead text-lg text-slate-700">
            Última actualización: {new Date().toLocaleDateString()}
          </p>

          <h3>1. Introducción</h3>
          <p>
            Bienvenido a EncuentraTrastero. Al acceder a nuestro sitio web y utilizar nuestros servicios, aceptas cumplir con estos términos y condiciones. 
            Nuestra plataforma actúa como un punto de encuentro entre propietarios de trasteros y personas interesadas en alquilarlos o comprarlos.
          </p>

          <h3>2. Uso de la Plataforma</h3>
          <p>
            El uso de EncuentraTrastero es gratuito para la publicación de anuncios y la búsqueda de espacios. 
            Te comprometes a utilizar el servicio de manera lícita y a no publicar contenido falso, ofensivo o que vulnere derechos de terceros.
          </p>

          <h3>3. Responsabilidad</h3>
          <p>
            EncuentraTrastero no es propietario de los espacios anunciados ni interviene en las transacciones entre usuarios. 
            No nos hacemos responsables de la veracidad de los anuncios ni del cumplimiento de los acuerdos entre particulares.
            Recomendamos siempre visitar el espacio y formalizar un contrato por escrito antes de realizar cualquier pago.
          </p>

          <h3>4. Publicación de Anuncios</h3>
          <p>
            Al publicar un anuncio, garantizas que eres el propietario del espacio o tienes autorización para gestionarlo. 
            Nos reservamos el derecho de retirar cualquier anuncio que incumpla nuestras normas o parezca fraudulento.
          </p>

          <h3>5. Modificaciones</h3>
          <p>
            Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios entrarán en vigor desde su publicación en esta página.
          </p>
        </div>
      </div>
    </div>
  );
}
